class MSubnavMedia {
	/** @param {HTMLElement} element */
	constructor(element) {
		this.headerElement = element.closest('.o-header');
		this.buttonElements = element.querySelectorAll('button');
		this.popoverElements = this.headerElement.querySelectorAll('[data-popover-id][data-stack="2"]');
		this.filterListElement = element.querySelector('.m-subnav-media__filter ul');

		const observeElement = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.type === 'attributes' && mutation.target.hidden === false) {
					this.scrollActiveElementInView();
				}
			});
		});

		const observerPopover = new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.type === 'attributes') {
					// Toggle aria-pressed when hidden attribute changes
					[...this.buttonElements]
						.filter((_) => _.dataset.popovertarget === mutation.target.dataset.popoverId)
						.forEach((_) => _.setAttribute('aria-pressed', !mutation.target.hidden));
				}
			});
		});

		observeElement.observe(element, {
			attributes: true,
		});

		this.popoverElements.forEach((popoverElement) => {
			observerPopover.observe(popoverElement, {
				attributes: true,
			});
		});

		this.buttonElements.forEach((buttonElement) => {
			buttonElement.addEventListener('click', () => {
				const popoverTargetElement = [...this.popoverElements]
					.find((_) => _.dataset.popoverId === buttonElement.dataset.popovertarget);
				this.hideOtherPopovers(popoverTargetElement);

				popoverTargetElement?.toggleAttribute('hidden', false);
			});
		});

		this.scrollActiveElementInView();
	}

	scrollActiveElementInView() {
		const { filterListElement } = this;
		if (filterListElement?.querySelector('li:has([aria-pressed="true"])')) {
			filterListElement.scroll({
				left: filterListElement.querySelector('li:has([aria-pressed="true"])').offsetLeft - 32,
				behavior: 'smooth',
			});
		}
	}

	hideOtherPopovers(exceptElement = null) {
		const { headerElement } = this;
		[...headerElement.querySelectorAll('[data-popover-id][data-stack="2"]')]
			.filter((_) => _ !== exceptElement)
			.forEach((_) => _.toggleAttribute('hidden', true));
	}
}

document.querySelectorAll('.m-subnav-media').forEach((_) => new MSubnavMedia(_));
